import { EventEmitter } from 'utils/event-emitter';

export type TimerStartEvent = { type: 'start'; data: { cardId: string } };

export type TimerPauseEvent = { type: 'pause'; data: { cardId: string } };

export const TimerEvEm = new EventEmitter<TimerStartEvent | TimerPauseEvent>();
